"use client"

import { Img } from "@/components/ui/image"
import { AppChannel, Channel } from "@/config/channel"
import { useConfigParams } from "@/hooks"
import { isMobile } from "@/lib/is-mobile"
import { triggerSurveyBasedOnPathnameSnai } from "@/lib/sandsiv/survey-utils-snai"
import Link from "next/link"
import { BaseCloseButton } from "../base-close-button"
import { AppChannelsWithoutHeader } from "../header-config"
import { useCloseWithSurveyAction } from "../header-hooks"
import { SiteHeader } from "../site-header"

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const AppChannelsWithoutCloseButton: Channel[] = [
  AppChannel.AppMobileMobileSisalIt,
  AppChannel.AppRouletteGiocaOnLine,
]

const SnaiHeader = ({ isThankYouPage }: { isThankYouPage?: boolean }) => {
  /*--------------------hooks--------------------*/
  const { channel } = useConfigParams()

  const handleCloseClick = useCloseWithSurveyAction(
    !!isThankYouPage,
    triggerSurveyBasedOnPathnameSnai,
  )

  /*--------------------config--------------------*/
  const isLinkHeader = channel === AppChannel.PortaleWebFullResponsiveWwwSisalIt
  const hideSiteHeader =
    channel != null && AppChannelsWithoutHeader.includes(channel)
  const showCloseButton = !AppChannelsWithoutCloseButton.includes(channel)

  if (hideSiteHeader) return null

  return (
    <SiteHeader id="site-header">
      {isLinkHeader ? (
        <Link href={{ href: window.APP_MAIN_SITE_HOMEPAGE }} title="Snai">
          <AppLogo />
        </Link>
      ) : (
        <AppLogo />
      )}
      {showCloseButton && <BaseCloseButton onClick={handleCloseClick} />}
    </SiteHeader>
  )
}

function AppLogo() {
  return (
    <Img
      src={isMobile() ? "/logo/logo-snai-mobile.svg" : "/logo/logo-snai.svg"}
      alt="logo"
      width={isMobile() ? 39 : 74}
      height={19}
      className="max-h-7"
    />
  )
}

export { SnaiHeader }
